import { Component, OnInit, Input } from '@angular/core';
import { RendezVousSelectedDTO } from 'src/app/comite-credit/core/model/rendez-vous-selected-dto';
import { RendezVousService } from 'src/app/comite-credit/core/service/rendez-vous.service';
import { AssocierRequestAuComite } from 'src/app/comite-credit/core/model/associer-request-au-comite';
import { DossierService } from 'src/app/suivi-portefeuille/core/service/dossier.service';
import { Dossier } from 'src/app/suivi-portefeuille/core/model/dossier';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-commite-credit",
  templateUrl: "./commite-credit.component.html",
  styleUrls: ["./commite-credit.component.scss"]
})
export class CommiteCreditComponent implements OnInit {
  rendezVous: RendezVousSelectedDTO[];
  dossier: Dossier;
  requestId: string;
  checkIfComiteChoose = false;

  constructor(private _rendezVousService: RendezVousService,
    private _dossierService: DossierService,
    public activeModal: NgbActiveModal,

) {}

  ngOnInit() {
    this.getCurrentRendezVousByType(this.requestId, "CDCD");
    this.getDossierByNumDossier(this.requestId);

  }
  getCurrentRendezVousByType(requestId, typecomite) {
    this._rendezVousService
      .findSelectedDeclassement(requestId, typecomite)
      .subscribe(
        data => {
          this.rendezVous = data;

          let check = false;
          this.rendezVous.forEach(function(value) {
            if (value.selected == true) {
              check = true;
            }
          });
          this.checkIfComiteChoose = check;
        },
        error => {
          console.log(error);
        }
      );
  }

  changeAfterChecked(values: any, rendezVousId) {
    var input = new AssocierRequestAuComite();
    input.rendezVousId = rendezVousId;
    input.requestId = this.requestId;
    input.selected = values.currentTarget.checked;
    this.associer(input);
  }

  associer(associerProfileAEmployee: AssocierRequestAuComite) {
    this._rendezVousService
      .associerDeclassemet(associerProfileAEmployee, this.requestId)
      .subscribe(
        data => {
          this.getCurrentRendezVousByType(this.requestId, "CDCD");
        },
        error => {
          console.log(error);
        },
        () => {}
      );
  }

  getDossierByNumDossier(numDossier) {
    this._dossierService.getDossierByNumDossier(numDossier).subscribe(
      data => {
        this.dossier = data;
      },
      error => {
        console.log(error);
      }
    );
  }
}
